<template>
  <ScrollList v-if="0 !== attachments.length">
    <li
      v-for="(attachment, index) in attachments"
      class="attachment-gallery__item"
      @click="
        modalStore.toggleModal(reviewModal, { reviews, attachment, product })
      "
    >
      <img
        class="attachment-gallery__image"
        :src="
          attachment.url ?? getYoutubeVideoPreview(attachment.youtubeVideoId)
        "
        :alt="`review photo ${index + 1}`"
      />
      <ButtonYoutubePlay
        v-if="attachment.youtubeVideoId"
        :width="28"
        :height="18"
      />
    </li>
  </ScrollList>
</template>

<script setup>
import ScrollList from "~/modules/shared/scrollList/ScrollList.vue";
import {
  reviewModal,
  useModalStore,
} from "~/modules/shared/modals/store/modalStore.js";
import {
  getReviewAttachments,
  getYoutubeVideoPreview,
} from "~/utils/getters.utils.js";
import ButtonYoutubePlay from "~/modules/shared/youtubePlayer/ButtonYoutubePlay.vue";
import { Product } from "~/models/product.model.js";

const props = defineProps({
  reviews: { type: Array, required: true },
  product: { type: Product, required: true },
  itemWidth: { type: Number, required: false, default: 68 },
  itemHeight: { type: Number, required: false, default: 68 },
});

const modalStore = useModalStore();

const attachments = computed(() => {
  return props.reviews.flatMap((review) =>
    getReviewAttachments(review, "thumbnail"),
  );
});
</script>

<style scoped lang="scss">
.attachment-gallery {
  &__item {
    position: relative;

    @include fixedHW(
      calc(v-bind(itemHeight) * 1px),
      calc(v-bind(itemWidth) * 1px)
    );

    cursor: pointer;
  }

  &__image {
    width: 100%;
    height: 100%;

    border-radius: 8px;

    object-fit: cover;
  }
}
</style>
